import { getAccessToken } from '../../../selectors/personalPensionPlan/payments';
import {
    getBeneficiariesForms,
    getPersonalDataProcessingConsent,
} from '../../../selectors/personalPensionPlan/beneficiaries';
import { getIsApiPending } from '../../../selectors/personalPensionPlan/beneficiaries';
import axios from 'axios';
import { getCustomerIdValue } from '../../../selectors/personalPensionPlan/personalDetails';
import { apiTransitionBeneficiariesForm } from '../../../actions/personalPensionPlan/beneficiaries';
import { setExpiredAuth } from '../../../actions/personalPensionPlan/quote';

export const payloadBeneficiariesService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionBeneficiariesForm.pending());
            try {
                const resp = await makeSubmission(store.getState());
                if (resp.data) {
                    store.dispatch(apiTransitionBeneficiariesForm.success());
                }
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionBeneficiariesForm.failure());
            }
        }
    })();
    return next(action);
};

const createBeneficiaries = (beneficiariesDetails) => {
    const beneficiaries = [];

    for (let i = 0; i < beneficiariesDetails.length; i++) {
        const beneficiary = beneficiariesDetails[i];

        beneficiaries.push({
            firstName: beneficiary.firstName?.value ? beneficiary.firstName?.value : 'N/A',
            lastName: beneficiary.lastName?.value ? beneficiary.lastName?.value : 'N/A',
            idNumber: beneficiary.idNumber?.value ? beneficiary.idNumber?.value : 'N/A',
            relationship: beneficiary.relationship?.value ? beneficiary.relationship?.value : 'N/A',
            location: beneficiary.location?.value ? beneficiary.location?.value : 'N/A',
            emailAddress: beneficiary.email?.value ? beneficiary.email?.value : 'N/A',
            percentageSplit: beneficiary.percentageSplit?.value ? beneficiary.percentageSplit?.value : 0,
            phoneNumber: beneficiary.phoneNumber?.value ? beneficiary.phoneNumber?.value : 'N/A',
        });
    }

    return beneficiaries;
};

const payloadCollection = (state) => {
    // get personal id
    const pid = getCustomerIdValue(state);
    const beneficiariesDetails = getBeneficiariesForms(state);
    const beneficiaries = createBeneficiaries(beneficiariesDetails);
    const consent = getPersonalDataProcessingConsent(state);

    const payload = {
        pension_id: pid.value,
        dataConsent: consent,
        beneficiaries: beneficiaries,
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-pension-plan/beneficiaries';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
